import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import MengelolaGajiKaryawan from "../../componen/gajiKaryawan/admin/MengelolaGajiKaryawan";

export const MengelolaGajiKaryawanPages = () => {
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate("/", { replace: true });
  }, [isError, navigate]);

  useEffect(() => {
    if (user && user.role !== "admin" && user.role !== "superadmin") {
      navigate("/dashboard", { replace: true });
    }
  }, [user, navigate]);

  return (
    <Layout>
      <MengelolaGajiKaryawan />
    </Layout>
  );
};
